import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../app/axios";
import { API_URL } from "../../../app/config";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";

export const uploadPortDataFile = createAsyncThunk(
  "ExportBulkExcel/InsertExportBulkExcel",
  async (fileData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ExportBulkExcel/InsertExportBulkExcel`,
        fileData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      console.error("Error  File uploading", error);
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllPortDataimport = createAsyncThunk(
  "ExportBulkExcel/FindAllExportBulkExcel",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ExportBulkExcel/FindAllExportBulkExcel`,
        formdata
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Port Data import:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
